import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { setReportData } from "Pages/ReportsAlerts/Reports/@signals"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks/index"


export default function useReportHandleStatus(idReport, rowData = {}) {
	const { showToast } = useToast()
	const { backendUrl } = useReportBackendApiPath()

	const handleStatus = useCallback(newStatus => {
		setReportData({ idReport: idReport, enabled: newStatus })
		postSubmit(`${backendUrl}/${newStatus ? "enable" : "disable"}`, { idReport })
			.catch(() => {
				showToast.error(`Error changing the status of report ${rowData.name}.`)
				setReportData({ idReport: idReport, enabled: !newStatus })
			})
	}, [idReport])

	return { handleStatus }
}